import {
  Share2,
  GitFork,
  History,
  Globe,
  Lock,
  Users,
  Image,
  BookOpen,
} from 'lucide-react';
import type { FeatureGroup } from '../types';

export const publishingGroup: FeatureGroup = {
  id: 'publishing',
  label: 'Publishing & Community',
  headline: "Share your work, build on others'",
  summary:
    'Every Meshpit model has a clean URL. Fork any public design, track your changes with version history, and embed live 3D models anywhere with a single iframe tag.',
  accentClass: 'from-green-500 to-lime-400',
  items: [
    {
      icon: Share2,
      title: 'Shareable URLs',
      description:
        'Every model gets a permanent, clean URL. Share a link and anyone can view and interact with your model instantly — no account required to view.',
      tier: 'major',
    },
    {
      icon: GitFork,
      title: 'Fork & Remix',
      description:
        'Fork any public model with one click. The fork is immediately yours to modify and publish. Credit to the original is preserved automatically.',
      tier: 'major',
    },
    {
      icon: History,
      title: 'Version History',
      description:
        'Every save creates a version entry. Add commit messages, preview any past version, and restore with a single click — a full Git-style history for your designs.',
      tier: 'major',
    },
    {
      icon: Globe,
      title: 'Embeddable Iframe',
      description:
        'Embed a live, interactive 3D viewer into any website or blog post with a single iframe tag. Visitors can rotate, zoom, and adjust parameters — no Meshpit account needed.',
      tier: 'major',
    },
    {
      icon: Lock,
      title: 'Public & Private Models',
      description:
        'Control visibility per model. Keep works-in-progress private, publish finished designs to the community, or share an unlisted link with collaborators.',
      tier: 'major',
    },
    {
      icon: Users,
      title: 'Explore & Profiles',
      description:
        'Browse a growing library of community models on the Explore page. Every creator has a public profile page listing all their published designs.',
      tier: 'major',
    },
    {
      icon: Image,
      title: 'Automatic Thumbnails',
      description:
        'When you save a model, the current viewport is automatically captured and uploaded as the public thumbnail — no manual screenshot step required.',
      tier: 'minor',
    },
    {
      icon: BookOpen,
      title: 'Blog & Guides',
      description:
        'A full blog with tutorials, API references, and showcase articles — featuring embedded live ScadPlayground components so every example is interactive and runnable.',
      tier: 'minor',
    },
  ],
};
